import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

interface StateProps {
  onBoardingStatus: EditorMobileOnboardingStatus;
  hasOnboardingCompleted?: boolean;
}

export enum EditorMobileOnboardingStatus {
  NONE = '',
  AUTOSAVE = 'AUTOSAVE',
  TIMELINE_MOBILE = 'TIMELINE_MOBILE',
}

const initialState: StateProps = {
  onBoardingStatus: EditorMobileOnboardingStatus.NONE,
  hasOnboardingCompleted: false,
};

const editorMobileOnboardingSlice = createSlice({
  name: 'editorMobileOnboarding',
  initialState,
  reducers: {
    startOnboarding(state) {
      state.onBoardingStatus = EditorMobileOnboardingStatus.AUTOSAVE;
    },
    endOnboarding(state) {
      state.hasOnboardingCompleted = true;
      state.onBoardingStatus = EditorMobileOnboardingStatus.NONE;
    },
    toggleOnboardingState(state, action: PayloadAction<EditorMobileOnboardingStatus>) {
      state.onBoardingStatus = action.payload;
    },
  },
});

export const {startOnboarding, endOnboarding, toggleOnboardingState} = editorMobileOnboardingSlice.actions;
export const editorMobileOnboardingReducer = editorMobileOnboardingSlice.reducer;
